var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from "vue";
import { DgConnector } from "./datagrepper";
var dgConnector = new DgConnector("https://apps.fedoraproject.org/datagrepper");
var State;
(function (State) {
    State[State["loading"] = 0] = "loading";
    State[State["idle"] = 1] = "idle";
    State[State["error"] = 2] = "error";
    State[State["requestLoadMore"] = 3] = "requestLoadMore";
})(State || (State = {}));
var Time;
(function (Time) {
    Time[Time["week"] = 604800] = "week";
    Time[Time["month"] = 2628000] = "month";
    Time[Time["year"] = 31540000] = "year";
})(Time || (Time = {}));
export default Vue.extend({
    data: function () {
        return {
            // UI
            state: State.loading,
            errMsg: "",
            State: State,
            // Data from DG
            messages: [],
            pages: 0,
            currentPage: 0,
            count: 0,
            // To control DG queries
            end: Math.round(Date.now() / 1000),
            delta: Time.week,
            firstLoad: true
        };
    },
    mounted: function () {
        this.loadPage();
        this.setupObserver();
    },
    methods: {
        loadPage: function (removedDelta) {
            return __awaiter(this, void 0, void 0, function () {
                var dgParamaters, dgData, ignoredErrors;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.state = State.loading;
                            dgParamaters = this.findDgParams(removedDelta);
                            if (dgParamaters === null || dgParamaters === void 0 ? void 0 : dgParamaters.noLoad) {
                                return [2 /*return*/];
                            }
                            return [4 /*yield*/, dgConnector.getMessages(this.$package, dgParamaters)];
                        case 1:
                            dgData = _a.sent();
                            if (typeof dgData !== "object") {
                                ignoredErrors = [
                                    "TypeError: NetworkError when attempting to fetch resource."
                                ];
                                console.log(dgData);
                                if (!ignoredErrors.includes(dgData)) {
                                    this.errMsg = dgData;
                                    this.state = State.error;
                                }
                                return [2 /*return*/];
                            }
                            this.messages = this.messages.concat(dgData.messages);
                            this.pages = dgData.pages;
                            this.currentPage = dgData.page;
                            this.count = dgData.count;
                            this.firstLoad = false;
                            this.state = State.idle;
                            // Try to load more if we aren't able to find anything on inital load
                            if (this.count === 0) {
                                this.loadPage();
                            }
                            return [2 /*return*/];
                    }
                });
            });
        },
        findDgParams: function (changedDelta) {
            /*
              Find the delta, page, and end paramaters for dg queries.
              Incements the page if there are more pages. Otherwise,
              Changes delta to a month if nothing found in a week or no more pages.
              If that runs out/has no data, then prompts user to load a year of dg data.
            */
            var page = this.currentPage;
            if (this.currentPage < this.pages) {
                page += 1;
                // make sure at least one request has been made before changing delta
            }
            else if (!this.firstLoad) {
                if (this.delta === Time.week) {
                    this.end -= Time.week;
                    this.delta = Time.month;
                    page = 1;
                }
                else if (this.delta === Time.month) {
                    // Request to load more results
                    this.state = State.requestLoadMore;
                    this.loadNextPage = this.count !== 0;
                    return { noLoad: true };
                }
                else if (changedDelta) {
                    // Delta just changed to a year, reset pagination
                    page = 1;
                }
                else {
                    // No more results
                    this.state = State.idle;
                    return { noLoad: true };
                }
            }
            return {
                page: page,
                end: this.end,
                delta: this.delta
            };
        },
        setupObserver: function () {
            var observer = new IntersectionObserver(this.loadMore, { threshold: 1 });
            var scrollTrigger = document.querySelector('#scrollTrigger');
            if (scrollTrigger) {
                observer.observe(scrollTrigger);
            }
        },
        loadMore: function (entries) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.state != State.idle) {
                                return [2 /*return*/];
                            }
                            if (!entries[0].isIntersecting) {
                                return [2 /*return*/];
                            }
                            return [4 /*yield*/, this.loadPage()];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        },
        setDeltaToYear: function () {
            this.delta = Time.year;
            this.end -= Time.month;
            this.loadPage(true);
        }
    },
});
